import React from 'react'
import ReconfirmRoutes from './ReconfirmRoutes'

const Reconfirm = () => <ReconfirmRoutes />

export default Reconfirm
